<template>
  <RevButton
    v-if="displayCta"
    :full-width="fullWidth"
    :target="target"
    :to="ctaLink?.link"
    variant="secondary"
    @click="sendTrackingData"
  >
    {{ ctaLink?.label }}
  </RevButton>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { CTALink } from '@backmarket/http-api/src/api-specs-content/models/cta-link'
import type { Tracking } from '@backmarket/http-api/src/api-specs-content/models/tracking'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import { type FullWidth, RevButton } from '@ds/components/Button'

import { useLinkTarget } from '../../helpers/link-target/useLinkTarget'

const props = defineProps<{
  ctaLink?: CTALink
  tracking?: Tracking
  fullWidth?: FullWidth
}>()

const { trackClick } = useTracking()

const displayCta = computed(() => !isEmpty(props.ctaLink))

const target = useLinkTarget(props.ctaLink?.link)

function sendTrackingData() {
  if (isEmpty(props.tracking)) return
  trackClick(props.tracking)
}
</script>
